import React from 'react';
import LiveStats from './LiveStats';

function LiveStatsEmbed() {
  return (
    <div style={{ background: 'white' }}>
      <LiveStats />
    </div>
  );
}

export default LiveStatsEmbed;


